'use strict';

var _createClass = require("/Users/zl22222222/myagent/_work/5/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/Users/zl22222222/myagent/_work/5/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var RTFSpan = /*#__PURE__*/_createClass(function RTFSpan(opts) {
  _classCallCheck(this, RTFSpan);

  if (!opts) opts = {};
  this.value = opts.value;
  this.style = opts.style || {};
});

module.exports = RTFSpan;